<template>
  <div>

    <b-nav-item-dropdown
        right
        extra-toggle-classes="no-dropdown-caret"
        qid="navbar-notifications-toggle"
        @toggle="loadNotifications"
        v-b-tooltip.hover
        :title="$t('notifications.page_title')"
    >
      <!-- Using 'button-content' slot -->
      <template slot="button-content">
        <span>
          <font-awesome-icon icon="bell"/>
          <span class="notification-badge" v-if="unreadCount">
            {{unreadCount}}
          </span>
        </span>
      </template>

      <div class="text-center mt-4 mb-4" v-if="loading">
        <span>{{ $t('system.loading') }}</span>
        <br><br>
        <span>
          <font-awesome-icon icon="spinner" size="lg" class="fa-spin"/>
        </span>
      </div>

      <div v-if="unread_items && unread_items.length">
        <div class="text-muted pl-2 mb-2 mt-2">
          {{ $t('notifications.new') }}
        </div>
        <div
            v-for="(notification, index) in unread_items"
            class="notification-item"
            :key="'unread-' + index"
        >
          <ValidationNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\Validation'"/>
          <OwnerNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\Owner'"/>
          <ReportNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\ReportGenerated'"/>
          <ProjectCreatedNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\ProjectCreated'"/>
          <ProjectCompletedNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\ProjectCompleted'"/>
          <ExportNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\ExportGenerated'"/>
          <PolicyDocumentAddedNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\PolicyDocumentAdded'"/>
          <PolicyDocumentUpdatedNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\PolicyDocumentUpdated'"/>
          <PolicyDocumentPublishedNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\PolicyDocumentPublished'"/>
          <PolicyDocumentReadyToPublishNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\PolicyDocumentReadyToPublish'"/>
          <AttachmentNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\AttachmentsGenerated'"/>

          <CollectionTaskComment :notification="notification" v-if="notification.type === 'App\\Notifications\\CollectionTaskComment'"/>
          <CollectionTaskCompleted :notification="notification" v-if="notification.type === 'App\\Notifications\\CollectionTaskCompleted'"/>
          <CollectionTaskReopened :notification="notification" v-if="notification.type === 'App\\Notifications\\CollectionTaskReopened'"/>
          <TaskComment :notification="notification" v-if="notification.type === 'App\\Notifications\\TaskComment'"/>

          <ProjectOverdueNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\ProjectOverdue'"/>

        </div>
      </div>

      <div v-if="read_items && read_items.data && read_items.data.length">
        <div class="text-muted pl-2 mb-2 mt-2">
          {{ $t('notifications.earlier') }}
        </div>
        <div
            v-for="(notification, index) in read_items.data"
            class="notification-item"
            :key="'read-' + index"
        >
          <ValidationNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\Validation'"/>
          <OwnerNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\Owner'"/>
          <ReportNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\ReportGenerated'"/>
          <ProjectCreatedNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\ProjectCreated'"/>
          <ProjectCompletedNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\ProjectCompleted'"/>
          <ExportNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\ExportGenerated'"/>
          <PolicyDocumentAddedNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\PolicyDocumentAdded'"/>
          <PolicyDocumentUpdatedNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\PolicyDocumentUpdated'"/>
          <PolicyDocumentPublishedNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\PolicyDocumentPublished'"/>
          <PolicyDocumentReadyToPublishNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\PolicyDocumentReadyToPublish'"/>
          <AttachmentNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\AttachmentsGenerated'"/>

          <CollectionTaskComment :notification="notification" v-if="notification.type === 'App\\Notifications\\CollectionTaskComment'"/>
          <CollectionTaskCompleted :notification="notification" v-if="notification.type === 'App\\Notifications\\CollectionTaskCompleted'"/>
          <CollectionTaskReopened :notification="notification" v-if="notification.type === 'App\\Notifications\\CollectionTaskReopened'"/>
          <TaskComment :notification="notification" v-if="notification.type === 'App\\Notifications\\TaskComment'"/>
          <ProjectOverdueNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\ProjectOverdue'"/>
        </div>
      </div>

      <div class="text-center pt-2 pb-2">
        <router-link
          to="/notifications"
          qid="notifications-page-link"
        >
          {{ $t('notifications.view_all') }}
        </router-link>
      </div>

    </b-nav-item-dropdown>
  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js';
  import ValidationNotification from '@/components/notification/ValidationNotification.vue';
  import OwnerNotification from '@/components/notification/OwnerNotification.vue';
  import ReportNotification from '@/components/notification/ReportGeneratedNotification.vue';
  import ProjectCreatedNotification from '@/components/notification/ProjectCreatedNotification.vue';
  import ProjectCompletedNotification from '@/components/notification/ProjectCompletedNotification.vue';
  import ExportNotification from '@/components/notification/ExportNotification.vue';
  import PolicyDocumentAddedNotification from '@/components/notification/PolicyDocumentAddedNotification.vue';
  import PolicyDocumentUpdatedNotification from '@/components/notification/PolicyDocumentUpdatedNotification.vue';
  import PolicyDocumentPublishedNotification from '@/components/notification/PolicyDocumentPublishedNotification.vue';
  import PolicyDocumentReadyToPublishNotification from '@/components/notification/PolicyDocumentReadyToPublishNotification.vue';
  import AttachmentNotification from '@/components/notification/AttachmentsGeneratedNotification.vue';
  import CollectionTaskComment from '@/components/notification/CollectionTaskComment.vue';
  import CollectionTaskCompleted from '@/components/notification/CollectionTaskCompleted.vue';
  import CollectionTaskReopened from '@/components/notification/CollectionTaskReopened.vue';
  import TaskComment from '@/components/notification/TaskComment.vue';
  import ProjectOverdueNotification from '@/components/notification/ProjectOverdueNotification.vue';

  export default {
    name: 'Notifications',
    data: function () {
      return {
        activeNavbar: this.$store.state.activeNavbar,
        read_items: [],
        unread_items: [],
        unreadCount: 0,
        currentPage: 1,
        totalRows: 0,
        loading: true
      }
    },
    props: {},
    components: {
      ValidationNotification,
      OwnerNotification,
      ReportNotification,
      ProjectCreatedNotification,
      ProjectCompletedNotification,
      ExportNotification,
      PolicyDocumentAddedNotification,
      PolicyDocumentUpdatedNotification,
      PolicyDocumentPublishedNotification,
      PolicyDocumentReadyToPublishNotification,
      AttachmentNotification,
      CollectionTaskComment,
      CollectionTaskCompleted,
      CollectionTaskReopened,
      TaskComment,
      ProjectOverdueNotification
    },
    computed: {
      getNavType() {
        return this.$store.state.activeNavbar
      },
      getClient() {
        return this.$store.state.client
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function (newValue, oldValue) {
        if (newValue && oldValue && newValue.slug !== oldValue.slug) {
          this.loadCount();
        }
      }
    },
    methods: {
      loadCount() {
        let self = this;

        piincHttp.get('users/me/notifications/count').then(function (response) {
          self.unreadCount = response.data.unread_count;
        }, function () {});
      },
      loadNotifications(page) {
        // If page is not defined, set page to default 1
        let pageNumber = page ? page : 1;
        let self = this;

        piincHttp.get('users/me/notifications').then(function (response) {
          self.loading = false;
          self.read_items = response.data.read_items;
          self.unread_items = response.data.unread_items;
          self.loadCount()
        }, function () {});

      }
    },
    created() {
      let self = this;
      if (this.getClient && this.getClient.slug) {
        self.loadCount();
      }
    }
  }
</script>

<style scoped lang="scss">

</style>
